import {
  Box,
  Center,
  Divider,
  Flex,
  HStack,
  Image,
  Link,
  Text,
  VStack,
  useBreakpointValue,
} from "@chakra-ui/react";
import Footer from "../../components/common/Footer";
import Header from "../../components/common/Header";
import HelpdeskSideNav from "../../components/common/helpdeskSidenav";

import { useLocation, useNavigate } from "react-router-dom";
import master from "../../img/mastercardlogo.svg";
import remita from "../../img/remita.svg";
import verve from "../../img/vervelogo.svg";
import visa from "../../img/visalogo.svg";
import info_1 from "../../img/infographic_1.svg";
import info_2 from "../../img/infographic_2.svg";
import info_3 from "../../img/infographic_3.svg";
import routes from "../routes";

const PaymentGuidelines = () => {
  const showSideNav = useBreakpointValue({ base: false, lg: true });
  const navigate = useNavigate();
  const location = useLocation();

  const activeLink = (link: string) => {
    const style = {
      borderColor: "white",
      borderLeft: "",
      bgColor: "white",
      textColor: "#9E9E9E",
    };

    if (link === location.pathname) {
      style.borderColor = "#EC3337";
      style.borderLeft = "3px Solid";
      style.bgColor = "#FFFAFA";
      style.textColor = " #EC3337";
    }

    return style;
  };
  return (
    <>
      <Header />
      <Center
        pt={["30px", "72px"]}
        bgColor="#3362AB"
        height={["320px", "350px", "400px"]}
        width="100%"
        textAlign="center"
      >
        <Text color="white" fontSize={["34px", "48px"]} fontWeight="800">
          Guidelines: How to Make Remita <br /> Payments on our Portal
        </Text>
      </Center>

      {!showSideNav && (
        <HStack
          // overflowX="scroll"
          width={"100%"}
          height={"60px"}
          justifyContent={"space-around"}
          alignItems={"center"}
          fontSize={"13px"}
          padding={"0px 8px"}
        >
          <Link
            onClick={() => navigate(routes.HomeHelpdesk)}
            textAlign={"center"}
            alignContent={"center"}
            height={"60px"}
            borderBottom={activeLink(routes.HomeHelpdesk).borderLeft}
            borderColor={activeLink(routes.HomeHelpdesk).borderColor}
            color={activeLink(routes.HomeHelpdesk).textColor}
          >
            Help Desk Home{" "}
          </Link>
          <Divider orientation="vertical" height={"70%"} />
          <Link
            onClick={() => navigate(routes.HelpdeskNewRequest)}
            textAlign={"center"}
            alignContent={"center"}
            height={"60px"}
            borderBottom={activeLink(routes.HelpdeskNewRequest).borderLeft}
            borderColor={activeLink(routes.HelpdeskNewRequest).borderColor}
            color={activeLink(routes.HelpdeskNewRequest).textColor}
          >
            New Help Request
          </Link>
          <Divider orientation="vertical" height={"70%"} />
          <Link
            onClick={() => navigate(routes.PaymentGuidelines)}
            textAlign={"center"}
            alignContent={"center"}
            height={"60px"}
            borderBottom={activeLink(routes.PaymentGuidelines).borderLeft}
            borderColor={activeLink(routes.PaymentGuidelines).borderColor}
            color={activeLink(routes.PaymentGuidelines).textColor}
          >
            Payment Guideline
          </Link>
        </HStack>
      )}

      <Box bg="#F9F8F8" height="100%">
        <Flex width="90%" mx="auto" pt="80px">
          {showSideNav && <HelpdeskSideNav />}
          <VStack
            width={["90%", "70%", "60%"]}
            minHeight="90vh"
            spacing="2.4rem"
            height="auto"
            mb="4rem"
            mx="auto"
            bg="white"
            padding={["1.5rem", "3.4rem", "4rem"]}
          >
            <Text>
              Following the directive by the Federal Government on TSA, all
              payments to Government agencies must be made via Remitta. See
              details on how to make payment online via Remitta using your Debit
              Card or paying at a Bank Branch:
            </Text>
            <VStack width={"100%"} justifyContent={"flex-start"}>
              <Text
                width="100%"
                fontSize={"14px"}
                color={"#EC3337"}
                textUnderlineOffset={"auto"}
                textDecoration={"underline"}
                textAlign={"left"}
                fontWeight={"600"}
              >
                STEP 1:
              </Text>
              <Box marginLeft={"1rem"} fontWeight={"500"}>
                <ul>
                  <li>
                    Upon successful login as a Trainee, click on the Payment
                    Console tab, Once the payment console page is displayed,
                    enter the Admission Number for the Training Program you
                    intend to pay for and click on Search{" "}
                    <strong>
                      (Note that you become eligible to make payments once you
                      have been 'Shortlisted' or 'Admitted' into a Training
                      Program)
                    </strong>
                  </li>
                </ul>
              </Box>
            </VStack>
            <VStack width={"100%"} justifyContent={"flex-start"}>
              <Text
                width="100%"
                fontSize={"14px"}
                color={"#EC3337"}
                textUnderlineOffset={"auto"}
                textDecoration={"underline"}
                textAlign={"left"}
                fontWeight={"600"}
              >
                STEP 2:
              </Text>
              <Image src={info_1} alt="" mr="auto" />
              <Box marginLeft={"1rem"} fontWeight={"500"}>
                <ul>
                  <li>
                    If your search is successful, Brief details about the
                    Training Program and your cummulative payment history will
                    be displayed. If you are eligible to make payment, a Text
                    box for Payment Amount will be made available. Enter the
                    desired amount and click on Next. Follow the process through
                    by cliking on the Next buttons.
                  </li>
                </ul>
              </Box>
            </VStack>
            <VStack width={"100%"} justifyContent={"flex-start"}>
              <Text
                width="100%"
                fontSize={"14px"}
                color={"#EC3337"}
                textUnderlineOffset={"auto"}
                textDecoration={"underline"}
                textAlign={"left"}
                fontWeight={"600"}
              >
                STEP 3:
              </Text>
              <Image src={info_2} alt="" mr="auto" />
              <Box marginLeft={"1rem"} fontWeight={"500"}>
                <ul>
                  <li>
                    On the Select Payment Method page, select Remita TSA Webpay
                    by clicking on the option button. Follow the process through
                    by cliking on the Next buttons
                  </li>
                </ul>
              </Box>
            </VStack>
            <VStack width={"100%"} justifyContent={"flex-start"}>
              <Text
                width="100%"
                fontSize={"14px"}
                color={"#EC3337"}
                textUnderlineOffset={"auto"}
                textDecoration={"underline"}
                textAlign={"left"}
                fontWeight={"600"}
              >
                STEP 4:
              </Text>
              <Image src={info_3} alt="" mr="auto" />
              <Box  fontWeight={"500"}>

                    For each Payment attempt, a unique Transaction Reference
                    Number is generated. kindly note this number as it may be
                    used to track your transaction in the future. Also all
                    payment attempts are logged in the Transaction Log page.<br></br>
                    Once the payment page is displayed, enter your Debit Card
                    Number, Expiry Date of your Card, CVV2 Number and your PIN
                    OR Copy the RRR generated and proceed to a bank branch to
                    make payment. For all payment attempts a notification email
                    shall be sent to you on the status of your payment
                    transaction. For successful payment, an auto-generated
                    payment acknowledgement slip is sent to your mail box, also,
                    your Training payment details on the portal is updated
                    automatically. Your payment slip is also available in the
                    Transaction Log page.
        
              </Box>
            </VStack>

            <VStack alignItems="flex-start" spacing="1.5rem" width="100%">
              <Text color="#616161" fontSize="14px">
                Supported Options
              </Text>
              <HStack spacing="2rem" flexWrap={"wrap"}>
                <Image src={remita} alt="" />
                <Image src={verve} alt="" />
                <Image src={master} alt="" />
                <Image src={visa} alt="" />
              </HStack>
            </VStack>

            <VStack
              spacing="0.3rem"
              width="100%"
              bgColor="rgba(0, 133, 255, 0.1)"
              height="auto"
              borderRadius="8px"
              padding="3.2rem"
              alignItems="flex-start"
              fontWeight="500"
              fontSize="14px"
            >
              <Text color="red">Payment Options on Remita via our Portal</Text>
              <Text>Master Card</Text>
              <Text>Visa Card</Text>
              <Text>Bank Branch</Text>
              <Text>Internet Banking</Text>
              <Text>Paga/Pocket Moni</Text>
            </VStack>
          </VStack>
        </Flex>
      </Box>
      <Footer />
    </>
  );
};

export default PaymentGuidelines;
